// Redux action types
export const RINGCENTRAL_CLICKTOCALL = 'one-state-ring-central/click-to-call';
